var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierarchicalStructureFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472.019,365.888h-14.903v-18.818c0-44.556-36.249-80.803-80.804-80.803H274.35v-69.593h44.7    c22.045,0,39.98-17.935,39.98-39.981V59.645c0-22.045-17.935-39.981-39.98-39.981H199.623c-22.045,0-39.98,17.935-39.98,39.981    v97.047c0,22.045,17.935,39.981,39.98,39.981h44.7v69.593H136.354c-44.556,0-80.803,36.248-80.803,80.803v18.818h-15.57    C17.935,365.888,0,383.823,0,405.869v46.486c0,22.045,17.935,39.98,39.981,39.98h61.166c22.045,0,39.98-17.935,39.98-39.98    v-46.486c0-22.046-17.935-39.981-39.98-39.981H85.578v-18.818c0-27.997,22.778-50.775,50.775-50.775h107.969v69.593h-15.569    c-22.046,0-39.981,17.935-39.981,39.981v46.486c0,22.045,17.935,39.98,39.981,39.98h61.166c22.045,0,39.98-17.935,39.98-39.98    v-46.486c0-22.046-17.935-39.981-39.98-39.981H274.35v-69.593h101.963c27.998,0,50.776,22.778,50.776,50.775v18.818h-16.237    c-22.045,0-39.98,17.935-39.98,39.981v46.486c0,22.045,17.935,39.98,39.98,39.98h61.166c22.046,0,39.981-17.935,39.981-39.98    v-46.486C512,383.823,494.065,365.888,472.019,365.888z",
    "data-original": "#000000",
    style: {}
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchicalStructureFilled);
export default __webpack_public_path__ + "static/media/hierarchical-structure-filled.421c53ad95e84bf51c7ec9bcdc7b3435.svg";
export { ForwardRef as ReactComponent };